module.exports = __webpack_public_path__ + "static/media/stadium.332e4c2c.png";